import React, { useMemo, useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import "./PickerField.css";

export default function PickerField({
  label,
  value,
  placeholder = "Select",
  onClick,
  disabled = false,
}) {
  return (
    <button
      type="button"
      className={`picker-field${disabled ? " picker-field--disabled" : ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      <span className="picker-field__copy">
        {label ? <span className="picker-field__label">{label}</span> : null}
        <span className={`picker-field__value${value ? "" : " picker-field__value--placeholder"}`}>
          {value || placeholder}
        </span>
      </span>
      <FiChevronDown className="picker-field__chevron" aria-hidden />
    </button>
  );
}

export function usePickerState(initialOpen = false) {
  const [open, setOpen] = useState(initialOpen);
  return useMemo(
    () => ({
      open,
      openPicker: () => setOpen(true),
      closePicker: () => setOpen(false),
    }),
    [open],
  );
}
